import React, { useEffect, useState } from "react";
import AddUsers from "./add_user";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { FiSearch } from "react-icons/fi";

function Users(props) {
  const [toggleAdd, setToggleAdd] = useState(false);
  const [users, setUsers] = useState([]);
  const [editUser, setEditUser] = useState({});
  const [showDelete, setShowDelete] = useState(false);
  const [selectedUser, setSelectedUser] = useState('');
const [searchTerm, setSearchTerm] = useState("");

  function addProductToggler() {
    setToggleAdd(!toggleAdd);
  }

  useEffect(() => {
    const getCompanies = async () => {
      try {
        const storedUsers = localStorage.getItem("users");

        if (storedUsers) {
          setUsers(JSON.parse(storedUsers));
        } else {
          const response = await axios.get(
            "https://api.dectwinservices.com/api/get-user"
          );
  

if (props.doEdit === 'Techie' || props.doEdit === 'Admin') {
  const filteredUsers = response.data.filter(user =>
    (user.company_id === props.clientData.comp_id || user.company_id === props.clientData.company_id) &&
    user.id !== props.clientData.id
  );
  setUsers(filteredUsers);
  localStorage.setItem("users", JSON.stringify(filteredUsers));
}

          else {
          setUsers(response.data);
          localStorage.setItem("users", JSON.stringify(response.data));
          }

        }
      } catch (e) {
        props.handleToast({
          toastMsg:
            "Something went wrong! Please Refresh page or check internet.",
          toastColor: "#FF0000",
        });
      }
    };
    getCompanies();
  }, [props]);


  const exportToExcel = () => {
    if (!users || users.length === 0) {
      console.error("No data to export.");
      return;
    }

    // Define the columns for the Excel file
    const formattedData = users.map((item) => ({
      "User Name": item.name,
      "User ID": item.staff_id,
      "Company ID": item.company_id,
      Contact: item.contact,
      Email: item.email,
      "User Role": item.is_admin,
      'Password': item.pass,
      // "Assigned Item": item.item_id,
      // "Assigned Date": item.item_assign_date,
      Designation: item.designation,
      Department: item.department,
    }));

    // Create a new worksheet
    const ws = XLSX.utils.json_to_sheet(formattedData);

    // Create a new workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Users");

    // Convert workbook to a binary Excel file
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    // Create a Blob and trigger download
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `Users.xlsx`);
  };

const handleDelUser = (com) => {
setSelectedUser(com);
setShowDelete(true);

}

const handleDelete = async () => {
  try {
    const response = await fetch(`https://api.dectwinservices.com/api/delete-user/${selectedUser.id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ item_id: selectedUser.item_id }),
    });

    if (response.ok) {
      props.handleToast({
        toastMsg: "User Removed Successfully!!!",
        toastColor: "#4CAF50",
      });
      setShowDelete(false);
      window.location.reload();
    } else {
      props.handleToast({
        toastMsg: "Something went wrong! Please check data or internet.",
        toastColor: "#FF0000",
      });
    }
  } catch (error) {
    console.error("Error deleting user:", error);
    props.handleToast({
      toastMsg: "Something went wrong! Please check data or internet.",
      toastColor: "#FF0000",
    });
  }
};

const filteredData = users.filter((p) =>
  p.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
  p.contact.toLowerCase().includes(searchTerm.toLowerCase()) ||
    p.staff_id.toLowerCase().includes(searchTerm.toLowerCase())
);

const clientIs = localStorage.getItem("exclserv_user");
const clientDetails = JSON.parse(clientIs);
  return toggleAdd ? (
    <AddUsers
      doEdit={props.doEdit}
      editUser={editUser}
      toggler={addProductToggler}
      handleToast={props.handleToast}
      handleLoading={props.handleLoading}
      closeLoading={props.closeLoading}
        currentUser={clientDetails}
    />
  ) : (
    <section className="px-32">
      <div className="d-md-flex justify-between">
        <div className="d-flex">
          <i className="bx bxs-user" style={{ fontSize: "24px" }}></i>
          <p className="fw-bolder fs-big">&nbsp;User's Overview</p>
        </div>
<div className="d-md-flex d-sm-flex">

 <div className="my-2 px-1">        <button
            className="add-btn"
            style={{ background: "#00AA00" }}
            onClick={exportToExcel}
          >
            <i className="bx bxs-download" style={{ fontSize: "22px" }}></i>
            &nbsp; Export to Excel
          </button>
          </div>  
     <div className="my-2 px-1">    <button
            className="add-btn"
            onClick={() => {
              setEditUser({});
              addProductToggler();
            }}
          >
            <i className="bx bxs-plus-circle" style={{ fontSize: "22px" }}></i>
            &nbsp; Add User
          </button>
          </div>  
        </div>
      </div>

    <div className="form-data col-md-4 col-12">
      <div className="input-icon bg-white">
        <i className="bx bxs-search"></i>

      <input
        type="text"
        className="p-2"
        placeholder="Search by name"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
    </div>

    </div>


     <div className="bg-white table-responsive rounded-3">
        <table className="table w-100">
                   <thead className="bg-grey">

              <th className="p-2">User ID</th>
              <th className="p-2">Name</th>
              <th className="p-2">Company ID</th>
              <th className="p-2">Role</th>
              <th className="p-2">Designation</th>
              <th className="p-2">Email</th>
              <th className="p-2">Assigned Item</th>
              {/* <th style={{flex: '1'}}>Asset Code</th> */}
              <th className="p-2 text-center">
                <i className="bx bxs-cog rounded-circle bg-grey p-0"></i>
              </th>
          </thead>

              {filteredData.map((com, index) => (
                <tr key={index}>
                  <td className="p-2">{com.staff_id}</td>
                  <td className="p-2">{com.name}</td>
                  <td className="p-2">{com.company_id}</td>
                  <td className="p-2">{com.is_admin}</td>
                  <td className="p-2">{com.designation || 'NA'}</td>
                  <td className="p-2">{com.email}</td>
              {/* <td style={{flex: '1'}}>{com.product_name} ({com.product_assetcode } ) </td> */}
              <td className="p-2"
  style={{ maxWidth: "200px", whiteSpace: "normal", wordBreak: "break-word"}}>
  {com.product_name || ""}
  {com.product_assetcode ? ` (${com.product_assetcode})` : ""}
</td>
              {/* <td style={{flex: '1'}}>{com.product_assetcode}</td> */}
                  <td className="p-2">
                    <i
                      title="Edit Product"
                      style={{ fontSize: "24px", cursor: "pointer", color: 'blue' }}
                      className="bx bxs-edit"
                      onClick={() => {
                        setEditUser(com);
                        addProductToggler();
                      }}
                    >
                      
                    </i>
                                        <i
                      title="Delete Product"
                      style={{ fontSize: "24px", cursor: "pointer", color: 'red' }}
                      className="bx bxs-trash"
                      onClick={() => {
                        handleDelUser(com)
                      }}
                    ></i>
                  </td>
                </tr>
              ))}
          </table>
      </div>

      {showDelete && (
        <>
            <div className="ticket-popup">
      <div className="accept-ticket">

<h4 style={{textAlign: 'center'}}>Really Want to Remove User "{selectedUser.name}"?</h4>
        <div className="btn-group d-flex" style={{ justifyContent: "center" }}>
          <button
            className="add-btn"
            style={{ background: "#ec0e0e" }}
            onClick={() => setShowDelete(false)}
          >
            Go Back
          </button>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <button className="add-btn" onClick={handleDelete}>
            Remove
          </button>
        </div>

</div>
</div>
        </>
      )}
    </section>
  );
}

export default Users;
